// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"310":"a26c6629ea74ab1d","363":"06e18b3db0fb243c"}[chunkId] + ".css";
};